export default function ErrorMessage(props) {
    return (
        <div role="alert">
        <div className="text-sm rounded bg-red-100 px-4 py-3 text-red-700">
            <p>{props.message}</p>
        </div>
        </div>
    )
}